var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    transform: "translate(-1022 -4322)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1022 4322)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1018 -4321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.189,25.241a3.347,3.347,0,0,0-2.865-2.606,98.969,98.969,0,0,0-9.924-.366,98.313,98.313,0,0,0-9.906.366,3.2,3.2,0,0,0-1.847.839,3.427,3.427,0,0,0-1.035,1.785,30.869,30.869,0,0,0-.464,6.247,30.235,30.235,0,0,0,.464,6.247,3.293,3.293,0,0,0,1.026,1.785,3.15,3.15,0,0,0,1.838.821,92.732,92.732,0,0,0,9.924.411,92.728,92.728,0,0,0,9.924-.384,3.106,3.106,0,0,0,1.829-.821,3.427,3.427,0,0,0,1.035-1.785,30.824,30.824,0,0,0,.464-6.247A30.271,30.271,0,0,0,36.189,25.241ZM17.716,27.025H15.8V37.2H14.013V27.052H12.138V25.366h5.578v1.687ZM22.508,37.2H20.947v-.892A2.624,2.624,0,0,1,19.162,37.4a.964.964,0,0,1-1.035-.66,4.355,4.355,0,0,1-.178-1.321V28.391h1.589V34.9a5.7,5.7,0,0,0,0,.625q.054.375.375.375.482,0,1.017-.75V28.391h1.58Zm6.077-2.677a6.613,6.613,0,0,1-.161,1.785,1.24,1.24,0,0,1-1.267.982,2.222,2.222,0,0,1-1.66-.982V37.2H23.936V25.366h1.6v3.882a2.142,2.142,0,0,1,1.66-.973,1.24,1.24,0,0,1,1.267,1,6.381,6.381,0,0,1,.161,1.785Zm6.051-1.464h-3.2v1.553c0,.821.277,1.232.821,1.232a.678.678,0,0,0,.714-.643,8.193,8.193,0,0,0,0-1.089H34.6v.232a6.631,6.631,0,0,1,.027,1.071,2.044,2.044,0,0,1-.375.973,2.186,2.186,0,0,1-1.928.964,2.294,2.294,0,0,1-1.928-.892,3.355,3.355,0,0,1-.527-2.079V31.264a3.4,3.4,0,0,1,.509-2.1,2.436,2.436,0,0,1,3.8,0,3.472,3.472,0,0,1,.491,2.07v1.847Z",
    transform: "translate(-10.135 -8.642)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.192,30.63a1.178,1.178,0,0,0-.812.393v5.355a1.142,1.142,0,0,0,.812.393c.464,0,.7-.393.7-1.2V31.853C28.888,31.032,28.656,30.63,28.192,30.63Z",
    transform: "translate(-11.99 -9.542)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.843,30.63c-.535,0-.8.411-.8,1.214v.83h1.606v-.821C35.646,31.041,35.379,30.63,34.843,30.63Z",
    transform: "translate(-12.707 -9.542)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,14.139v4.846h1.785V14.139L21.142,7H19.357l-1.214,4.712L16.832,7H14.94c.339,1.008.723,2.124,1.16,3.347a30.932,30.932,0,0,1,1.1,3.793Z",
    transform: "translate(-10.652 -7)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.291,19.508a2.2,2.2,0,0,0,1.892-.892,3.48,3.48,0,0,0,.5-2.115V13.377a3.471,3.471,0,0,0-.5-2.1,2.4,2.4,0,0,0-3.766,0,3.471,3.471,0,0,0-.509,2.1V16.5a3.57,3.57,0,0,0,.509,2.115A2.2,2.2,0,0,0,24.291,19.508Zm-.767-6.47c0-.821.25-1.24.767-1.24s.767.419.767,1.24V16.8c0,.83-.259,1.249-.767,1.249s-.767-.419-.767-1.249Z",
    transform: "translate(-11.401 -7.362)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.945,19.519a2.543,2.543,0,0,0,1.838-1.107v.982h1.651V10.47H31.784v6.818c-.357.509-.7.767-1.017.767s-.339-.134-.375-.393a5.436,5.436,0,0,1,0-.625V10.47H28.749v7.05a4.462,4.462,0,0,0,.143,1.339,1,1,0,0,0,1.053.66Z",
    transform: "translate(-12.137 -7.373)",
    fill: "#e8eaea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bf4f47cb15aa8ca4cacf4216eaa5d09f.svg";
export { ForwardRef as ReactComponent };